import {useEffect, useState, useRef} from 'react';
import { useMediaQuery } from '@mui/material';
import { BsPlusCircle as Add } from 'react-icons/bs';
import { MdGridView as GridIcon, MdViewList as ListIcon, MdUploadFile as UploadIcon, MdFolder as FolderIcon, MdInsertDriveFile as FileIcon, MdAccessTime as ClockIcon } from 'react-icons/md';
import { IoChevronForward as ChevronRight, IoClose as Close, IoSearch as SearchIcon } from 'react-icons/io5';
import CircularProgress from '@mui/material/CircularProgress';
import FileTypeFrame from '@CommonFunctionalDisplay/FileTypeFrame';
import FileRow from '@CommonFunctionalDisplay/FileRow';
import ProjectFolder from '@ProjectFunctionalDisplay/ProjectFolder';
import RecentItems from '@ProjectFunctionalDisplay/RecentItems';
import ProjectFolderRow from '@ProjectFunctionalDisplay/ProjectFolderRow';
import CreateFolder from '@ProjectFunctionalDisplay/CreateFolder';
import ErrorHandler from '@Root/ErrorHandler';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ManagementService from '@Helpers/URLHelpers/ManagementService';
import FolderProjectViewService from '@Helpers/URLHelpers/FolderProjectViewService';
import ProjectService from '@Helpers/URLHelpers/ProjectService';
import ProjectFolderService from '@Helpers/URLHelpers/ProjectFolderService';
import AgileFolderViewService from '@Helpers/URLHelpers/AgileFolderViewService/AgileFolderViewService';
import KaiziqManageConnectionService from '@Helpers/URLHelpers/KaiziqManageConnectionService/KaiziqManageConnectionService';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import TicketFolderViewService from '@Helpers/URLHelpers/KaiziqResolve/TicketFolderViewService';
import Grid from '@mui/material/Grid';
import { useReduxFileStorage } from '@Hooks/reduxFileStorageHook/useReduxFileStorage';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import FileService from '@Helpers/URLHelpers/FileService';
import './DocsPage.scss';

export default function DocsPage(props) {

    const [cursor, setCursor] = useState('auto');
    const [showRecentItems, setShowRecentItems] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [folderLoader, setFolderLoader] = useState(false);
    const [fileLoader, setFileLoader] = useState(false);
    const [kaiziqResolveConnectionList, setKaiziqResolveConnectionList] = useState([]);
    const [ticketFolderList, setTicketFolderList] = useState([]);
    const [ticketExportFileDetails, setTicketExportFileDetails] = useState({});
    const [agileExportFileDetails, setAgileExportFileDetails] = useState(null);
    const [agileExportFileDetailsLoader, setAgileExportFileDetailsLoader] = useState(false);
    const [ticketFileDetails, setTicketFileDetails] = useState({});
    const [filesFolders, setFilesFolders] = useState();
    const [agileFolderList, setAgileFolderList] = useState([]);
    const [agileFilesList, setAgileFilesList] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState({});
    const [showAgileFolder, setShowAgileFolder] = useState({});
    const [projectFiles, setProjectFiles] = useState();
    const [kaiziqManageConnectionList, setKaiziqManageConnectionList] = useState([]);
    const [internetException, setInternetException] = useState(false);
    const [viewType, setViewType] = useState('grid');
    const [navigationParent, setNavigationParent] = useState('project');
    const [displayType, setDisplayType] = useState('grid');
    const [navigationPath, setNavigationPath] = useState([]);
    const [navigationParentId, setNavigationParentId] = useState(0);
    const [selectedFolderType, setSelectedFolderType] = useState();
    const [selectedFolderId, setSelectedFolderId] = useState(0);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarType, setSnackBarType] = useState('success');
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [folderFileList, setFolderFileList] = useState([]);
    const [projectFilesList, setProjectFilesList] = useState([]);
    const [files, setFiles] = useState(null);
    const [contentLoader, setContentLoader] = useState(false);
    const inputRef = useRef();
    const fileService = new FileService();
    const errorHandler = new ErrorHandler();
    const managementService = new ManagementService();
    const folderProjectViewService = new FolderProjectViewService();
    const ticketFolderViewService = new TicketFolderViewService();
    const kaiziqManageConnectionService = new KaiziqManageConnectionService();
    const kaiziqResolveConnectionService = new KaiziqResolveConnectionService();
    const projectService = new ProjectService();
    const projectFolderService = new ProjectFolderService();
    const agileFolderViewService = new AgileFolderViewService();
    const is0To768 = useMediaQuery('(max-width: 768px)');
    const is0To1200 = useMediaQuery('(max-width: 1200px)');
    const { uploadFileInS3, uploadExistingFileInS3ByFileId } = useReduxFileStorage();
    const { currentProject, currentProjectId } = useReduxProject();
    const { activeUserId } = useReduxActiveUser();
    const className = 'docsPage';

    const handleFolderClick = async(folderType, folderId, folderDisplayName) => {
        setContentLoader(true);
        let folderPathObj = {
            pos: navigationPath?.length,
            folderType: folderType,
            folderId: folderId,
            folderDisplayName: folderDisplayName
        }
        let navigationPathList = navigationPath;
        setNavigationParent(folderType);
        setNavigationParentId(folderId);
        navigationPathList = [...navigationPathList, folderPathObj];
        setNavigationPath(navigationPathList);
        
        try {
            switch(folderType) {
                case 'projectFiles':
                    await renderProjectFilesList(folderId);
                    break;
                case 'tickets':
                    await renderKaiziqResolveConnectionListData();
                    break;
                case 'ticketFolderList':
                    await renderTicketFolderList(folderId);
                    break;
                case 'ticketFiles':
                    await renderTicketFiles(folderId);
                    break;
            }
        } finally {
            setContentLoader(false);
        }
    }

    const renderTicketFolderList = async (folderId) => {
        setCursor('wait');
        try {
            let ticketFolderListObj = await ticketFolderViewService.getTicketFolderListWithExports(folderId);
            ticketFolderListObj = JSON.parse(ticketFolderListObj.body);
            setTicketFolderList(ticketFolderListObj.ticketFolderList);
            setTicketExportFileDetails(ticketFolderListObj.exportsFile);
        } catch (err) {
            errorHandler.handleError(err);
        } finally {
            setCursor('auto');
        }
    }

    const renderTicketFiles = async (id)=> {
        let findFolder = ticketFolderList.find(item=> item.id === id);
        if(findFolder.fileDetails !== 'N/A') {
            let fileDetails = JSON.parse(findFolder.fileDetails);
            let fileIds = Object.keys(fileDetails);
            for(var i = 0; i < fileIds.length; i++){
                let fileId = fileIds[i];
                if(!isNaN(Number(fileId))) {
                    try {
                        let bodyObj = {
                            'fileId': fileId,
                            'tableType': 'TICKET',
                            'itemId': findFolder.id,
                        }
                        let uploadFile = await uploadExistingFileInS3ByFileId(bodyObj);
                        if(uploadFile.status < 400) {
                            let newFileObj = {...fileDetails[fileId]};
                            newFileObj.id = uploadFile.id;
                            newFileObj.publicUrl = uploadFile.publicUrl;
                            fileDetails[fileId] = {
                                ...fileDetails[fileId],
                                id: uploadFile.id,
                                publicUrl: uploadFile.publicUrl,
                            };
                        }
                    } catch(err) {}
                }
            }
            setTicketFileDetails({...fileDetails});
        }else {
            setTicketFileDetails({});
        }
    }

    const renderKaiziqResolveConnectionListData = async() => {
        try {
            let kaiziqResolveConnectionListObj = await kaiziqResolveConnectionService.getKaiziqResolveConnectionListByProject(currentProjectId);
            kaiziqResolveConnectionListObj = JSON.parse(kaiziqResolveConnectionListObj.body);
            setKaiziqResolveConnectionList(kaiziqResolveConnectionListObj);
        } catch (err) {
            errorHandler.handleError(err);
        }
    }

    const renderProjectFilesList = async(folderId) => {
        setFolderLoader(true);
        let parentType = (folderId === 0 || currentProjectId === folderId) ? 'project' : 'folder';
        let parentId = folderId === 0 ? currentProjectId : folderId;
        try {
            setFolderFileList([]);
            let fileList = await renderProjectFolderList(parentId, parentType);
            setProjectFilesList(fileList.folderLists);
            setFolderFileList(fileList.fileDetails);
        } catch(err) {
            errorHandler.handleError(err);
        }
        setFolderLoader(false);
    }

    const renderProjectFolderList = async(parentId, parentType) => {
        try {
            setFolderLoader(true);
            let projectFolderListObj = await folderProjectViewService.getFolderStructureByParentIdAndParentTypeAndUserId(parentId, parentType, activeUserId);
            projectFolderListObj = JSON.parse(projectFolderListObj.body);
            return projectFolderListObj;
        } catch (err) {
            errorHandler.handleError(err);
            return { folderLists: [], fileDetails: {} };
        } finally {
            setFolderLoader(false);
        }
    }

    const handleNavClick = (folderType, folderId, navIndex) => {
        setShowRecentItems(false);
        setNavigationParent(folderType);
        setNavigationPath(navigationPath.slice(0, navIndex + 1));
        setNavigationParentId(folderId);
        
        if(folderType === 'project') {
            setContentLoader(false);
        } else if(folderType === 'projectFiles') {
            renderProjectFilesList(folderId);
        }
    }

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if(!!file) {
            let fileSize = file.size/(1024*1024);
            if(fileSize > 2){
                setSnackBarMessage('File Size Too Large!');
                setSnackBarType('error');
                setSnackBarOpen(true);
            } else {
                const url = await convertFileToBase64(file);
                let newFileObj = {
                    file: url,
                    fileName: file.name,
                    fileSize: fileSize,
                    fileType: file.type,
                    projectId: navigationParentId
                }
                setFiles(newFileObj);
                await handleSubmit(newFileObj);
            }
        }
    };

    const handleSubmit = async (newFileObj)=> {
        setCursor('wait');
        let file = newFileObj;
        setFileLoader(true);
        try {
            let body = {
                'fileName': file.fileName,
                'tableType': showAgileFolder.tableType,
                'itemId': showAgileFolder.itemId,
                'file': file,
                'projectId': showAgileFolder.projectId,
                'userId': activeUserId,
                'storeType': 'attachment'
            }
            let response = await uploadFileInS3(body);
            setSnackBarMessage('File Attachment Successful!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            let fileObj = {
                ...body,
                ...newFileObj,
                id : response.id,
                previewImgUrl: newFileObj.file,
                createTimeStamp: new Date().getTime()
            }
            setAgileFilesList((prev)=> ({...prev, [response]: fileObj}));
            setFiles(null);
        } catch (err) {
            errorHandler.handleError(err);
            setSnackBarMessage('File Attachment has failed!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
        setFileLoader(false);
    }

    const handleChoose = () => {
        inputRef.current.click();
    };

    const convertFileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBarOpen(false);
    };

    const toggleRecentItems = ()=> {
        setShowRecentItems(!showRecentItems);
    }

    const handleViewTypeChange = (type)=> {
        setViewType(type);
    }

    const getFolderIcon = (folderType) => {
        switch(folderType) {
            case 'tickets': return '🎫';
            case 'projectFiles': return '📁';
            default: return '📁';
        }
    }

    return (
        <div className={className}>
            <div className={`${className}__container`}>
                {/* Top Toolbar */}
                <div className={`${className}__toolbar`}>
                    {/* Breadcrumb Navigation */}
                    <div className={`${className}__toolbar__left`}>
                        <div className={`${className}__breadcrumb`}>
                            <button 
                                className={`${className}__breadcrumb__item ${navigationPath.length === 0 ? 'active' : ''}`}
                                onClick={() => handleNavClick('project', currentProjectId, -1)}>
                                <FolderIcon />
                                <span>{currentProject?.projectName}</span>
                            </button>
                            {navigationPath?.map((nav, index) => (
                                <div key={index} className={`${className}__breadcrumb__wrapper`}>
                                    <ChevronRight className={`${className}__breadcrumb__separator`} />
                                    <button 
                                        className={`${className}__breadcrumb__item ${index === navigationPath.length - 1 ? 'active' : ''}`}
                                        onClick={() => handleNavClick(nav?.folderType, nav?.folderId, index)}>
                                        <span>{nav?.folderDisplayName}</span>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Search and Actions */}
                    <div className={`${className}__toolbar__right`}>
                        {/* Search Bar */}
                        <div className={`${className}__searchWrapper`}>
                            <TextField
                                size="small"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className={`${className}__search width-wfa`}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>

                        {/* Action Buttons Group */}
                        <div className={`${className}__actionGroup`}>
                            {/* Upload/Create Actions */}
                            {(navigationParent === 'projectFiles' || navigationParent === 'folder') && (
                                <CreateFolder
                                    navigationParent={navigationParent}
                                    navigationParentId={navigationParentId}
                                    renderData={renderProjectFilesList}
                                    fileSizeError={() => {
                                        setSnackBarMessage('File Size Too Large!');
                                        setSnackBarType('error');
                                        setSnackBarOpen(true);
                                    }}
                                    setCursor={setCursor}/>
                            )}

                            {navigationParent === 'agileFolder' && (
                                <>
                                    <input
                                        ref={inputRef}
                                        type='file'
                                        accept="audio/aac, audio/mp4, audio/mpeg, audio/amr, audio/ogg, audio/opus, application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, text/plain, application/vnd.ms-excel, image/jpeg, image/png, image/webp, video/mp4, video/3gpp"
                                        onChange={handleFileChange}
                                        style={{ display: 'none' }}/>
                                    <Tooltip title="Upload File" arrow placement="bottom">
                                        <IconButton onClick={handleChoose} className={`${className}__iconBtn`}>
                                            <UploadIcon />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}

                            {/* Recent Items */}
                            <Tooltip title="Recent Items" arrow placement="bottom">
                                <IconButton 
                                    onClick={toggleRecentItems} 
                                    className={`${className}__iconBtn ${showRecentItems ? 'active' : ''}`}>
                                    <ClockIcon />
                                </IconButton>
                            </Tooltip>

                            {/* View Toggle */}
                            <div className={`${className}__viewToggle`}>
                                <Tooltip title="Grid View" arrow placement="bottom">
                                    <IconButton 
                                        onClick={() => handleViewTypeChange('grid')}
                                        className={`${className}__viewBtn ${viewType === 'grid' ? 'active' : ''}`}>
                                        <GridIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="List View" arrow placement="bottom">
                                    <IconButton 
                                        onClick={() => handleViewTypeChange('list')}
                                        className={`${className}__viewBtn ${viewType === 'list' ? 'active' : ''}`}>
                                        <ListIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className={`${className}__content`}>
                    {showRecentItems ? (
                        <RecentItems />
                    ) : contentLoader || folderLoader ? (
                        <div className={`${className}__loading`}>
                            <CircularProgress size={48} />
                            <p>Loading contents...</p>
                        </div>
                    ) : (
                        <>
                            {/* Project Root View */}
                            {navigationParent === 'project' && (
                                viewType === 'grid' ? (
                                    <div className={`${className}__grid`}>
                                        <ProjectFolder
                                            folderName='Tickets'
                                            folderType='tickets'
                                            icon={getFolderIcon('tickets')}
                                            handleFolderClick={() => handleFolderClick('tickets', 0, 'Tickets')}/>
                                        <ProjectFolder
                                            folderName='Project Files'
                                            folderType='projectFiles'
                                            icon={getFolderIcon('projectFiles')}
                                            handleFolderClick={() => handleFolderClick('projectFiles', 0, 'Project Files')}/>
                                    </div>
                                ) : (
                                    <div className={`${className}__list`}>
                                        <ProjectFolderRow
                                            folderName='Tickets'
                                            folderType='tickets'
                                            icon={getFolderIcon('tickets')}
                                            handleFolderClick={() => handleFolderClick('tickets', 0, 'Tickets')}/>
                                        <ProjectFolderRow
                                            folderName='Project Files'
                                            folderType='projectFiles'
                                            icon={getFolderIcon('projectFiles')}
                                            handleFolderClick={() => handleFolderClick('projectFiles', 0, 'Project Files')}/>
                                    </div>
                                )
                            )}
                            {/* Tickets View */}
                            {navigationParent === 'tickets' && (
                                kaiziqResolveConnectionList?.length === 0 ? (
                                    <div className={`${className}__empty`}>
                                        <FolderIcon />
                                        <h3>No tickets found</h3>
                                        <p>There are no ticket connections for this project</p>
                                    </div>
                                ) : viewType === 'grid' ? (
                                    <div className={`${className}__grid`}>
                                        {kaiziqResolveConnectionList?.map((connection, index) => (
                                            <ProjectFolder
                                                key={index}
                                                folderName={connection?.formId}
                                                folderType='ticketFolderList'
                                                handleFolderClick={() => handleFolderClick('ticketFolderList', connection?.id, connection?.formId)}/>
                                        ))}
                                    </div>
                                ) : (
                                    <div className={`${className}__list`}>
                                        {kaiziqResolveConnectionList?.map((connection, index) => (
                                            <ProjectFolderRow
                                                key={index}
                                                folderName={connection?.formId}
                                                folderType='ticketFolderList'
                                                handleFolderClick={() => handleFolderClick('ticketFolderList', connection?.id, connection?.formId)}/>
                                        ))}
                                    </div>
                                )
                            )}

                            {/* Ticket Folder List */}
                            {navigationParent === 'ticketFolderList' && (
                                <>
                                    {ticketFolderList?.length === 0 && Object.keys(ticketExportFileDetails || {}).length === 0 ? (
                                        <div className={`${className}__empty`}>
                                            <FolderIcon />
                                            <h3>No content found</h3>
                                            <p>This ticket folder is empty</p>
                                        </div>
                                    ) : (
                                        <>
                                            {ticketFolderList?.length > 0 && (
                                                <div className={`${className}__section`}>
                                                    <h3 className={`${className}__section__title`}>
                                                        <FolderIcon />
                                                        Ticket Folders
                                                    </h3>
                                                    <div className={viewType === 'grid' ? `${className}__grid` : `${className}__list`}>
                                                        {ticketFolderList?.map((folder, index) => (
                                                            viewType === 'grid' ? (
                                                                <ProjectFolder
                                                                    key={index}
                                                                    folderName={folder?.ticketId}
                                                                    folderType='ticketFiles'
                                                                    handleFolderClick={() => handleFolderClick('ticketFiles', folder?.id, folder?.ticketId)}/>
                                                            ) : (
                                                                <ProjectFolderRow
                                                                    key={index}
                                                                    folderName={folder?.ticketId}
                                                                    folderType='ticketFiles'
                                                                    handleFolderClick={() => handleFolderClick('ticketFiles', folder?.id, folder?.ticketId)}/>
                                                            )
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {Object.keys(ticketExportFileDetails || {}).length > 0 && (
                                                <div className={`${className}__section`}>
                                                    <h3 className={`${className}__section__title`}>
                                                        <FileIcon />
                                                        Export Files
                                                    </h3>
                                                    <div className={viewType === 'grid' ? `${className}__grid` : `${className}__list`}>
                                                        {Object.keys(ticketExportFileDetails || {})?.map((fileId, index) => (
                                                            viewType === 'grid' ? (
                                                                <FileTypeFrame
                                                                    key={index}
                                                                    fileId={fileId}
                                                                    fileData={ticketExportFileDetails[fileId]}
                                                                    fileType={ticketExportFileDetails[fileId]?.fileType}
                                                                    fileName={ticketExportFileDetails[fileId]?.fileName}
                                                                    previewImgUrl={ticketExportFileDetails[fileId]?.previewImgUrl}
                                                                    viewType={viewType}/>
                                                            ) : (
                                                                <FileRow
                                                                    key={index}
                                                                    fileId={fileId}
                                                                    fileData={ticketExportFileDetails[fileId]}
                                                                    fileType={ticketExportFileDetails[fileId]?.fileType}
                                                                    fileName={ticketExportFileDetails[fileId]?.fileName}
                                                                    previewImgUrl={ticketExportFileDetails[fileId]?.previewImgUrl}/>
                                                            )
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            )}

                            {/* Ticket Files */}
                            {navigationParent === 'ticketFiles' && (
                                Object.keys(ticketFileDetails || {}).length === 0 ? (
                                    <div className={`${className}__empty`}>
                                        <FileIcon />
                                        <h3>No files found</h3>
                                        <p>This ticket doesn't have any files attached</p>
                                    </div>
                                ) : (
                                    <div className={viewType === 'grid' ? `${className}__grid` : `${className}__list`}>
                                        {Object.keys(ticketFileDetails || {})?.map((fileId, index) => (
                                            viewType === 'grid' ? (
                                                <FileTypeFrame
                                                    key={index}
                                                    fileId={fileId}
                                                    fileData={ticketFileDetails[fileId]}
                                                    fileType={ticketFileDetails[fileId]?.fileType}
                                                    fileName={ticketFileDetails[fileId]?.fileName}
                                                    previewImgUrl={ticketFileDetails[fileId]?.previewImgUrl}
                                                    viewType={viewType}/>
                                            ) : (
                                                <FileRow
                                                    key={index}
                                                    fileId={fileId}
                                                    fileData={ticketFileDetails[fileId]}
                                                    fileType={ticketFileDetails[fileId]?.fileType}
                                                    fileName={ticketFileDetails[fileId]?.fileName}
                                                    previewImgUrl={ticketFileDetails[fileId]?.previewImgUrl}/>
                                            )
                                        ))}
                                    </div>
                                )
                            )}

                            {/* Project Files View */}
                            {navigationParent === 'projectFiles' && (
                                <div className={`${className}__fileView`}>
                                    {projectFilesList?.length > 0 && (
                                        <div className={`${className}__section`}>
                                            <h3 className={`${className}__section__title`}>
                                                <FolderIcon />
                                                Folders
                                            </h3>
                                            {viewType === 'grid' ? (
                                                <div className={`${className}__grid`}>
                                                    {projectFilesList?.map((folder, index) => (
                                                        <ProjectFolder
                                                            key={index}
                                                            folderId={folder?.folderId}
                                                            navigationParentId={navigationParentId}
                                                            renderData={renderProjectFilesList}
                                                            folderName={folder?.folderName}
                                                            folder={folder}
                                                            folderType='projectFiles'
                                                            handleFolderClick={() => handleFolderClick('projectFiles', folder?.folderId, folder?.folderName)}/>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className={`${className}__list`}>
                                                    {projectFilesList?.map((folder, index) => (
                                                        <ProjectFolderRow
                                                            key={index}
                                                            folderId={folder?.folderId}
                                                            navigationParentId={navigationParentId}
                                                            renderData={renderProjectFilesList}
                                                            folderName={folder?.folderName}
                                                            folder={folder}
                                                            folderType='projectFiles'
                                                            handleFolderClick={() => handleFolderClick('projectFiles', folder?.folderId, folder?.folderName)}/>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {Object.keys(folderFileList || {}).length > 0 && (
                                        <div className={`${className}__section`}>
                                            <h3 className={`${className}__section__title`}>
                                                <FileIcon />
                                                Files
                                            </h3>
                                            <div className={viewType === 'grid' ? `${className}__grid` : `${className}__list`}>
                                                {Object.keys(folderFileList || {})?.map((fileId, index) => (
                                                    viewType === 'grid' ? (
                                                        <FileTypeFrame
                                                            key={index}
                                                            fileId={fileId}
                                                            fileData={folderFileList[fileId]}
                                                            fileType={folderFileList[fileId]?.fileType}
                                                            fileName={folderFileList[fileId]?.fileName}
                                                            navigationParentId={navigationParentId}
                                                            renderData={renderProjectFilesList}
                                                            viewType={viewType}/>
                                                    ) : (
                                                        <FileRow
                                                            key={index}
                                                            fileId={fileId}
                                                            fileData={folderFileList[fileId]}
                                                            fileType={folderFileList[fileId]?.fileType}
                                                            fileName={folderFileList[fileId]?.fileName}
                                                            navigationParentId={navigationParentId}
                                                            renderData={renderProjectFilesList}/>
                                                    )
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {projectFilesList?.length === 0 && Object.keys(folderFileList || {}).length === 0 && (
                                        <div className={`${className}__empty`}>
                                            <FolderIcon />
                                            <h3>This folder is empty</h3>
                                            <p>Add files and folders to get started</p>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Agile Folder Files View */}
                            {navigationParent === 'agileFolder' && (
                                <div className={`${className}__fileView`}>
                                    {fileLoader ? (
                                        <div className={`${className}__loading`}>
                                            <CircularProgress size={48} />
                                            <p>Uploading file...</p>
                                        </div>
                                    ) : Object.keys(agileFilesList || {}).length === 0 ? (
                                        <div className={`${className}__empty`}>
                                            <FileIcon />
                                            <h3>No files found</h3>
                                            <p>Upload files to this folder to get started</p>
                                        </div>
                                    ) : (
                                        <div className={viewType === 'grid' ? `${className}__grid` : `${className}__list`}>
                                            {Object.keys(agileFilesList || {})?.map((fileId, index) => (
                                                viewType === 'grid' ? (
                                                    <FileTypeFrame
                                                        key={index}
                                                        fileId={fileId}
                                                        fileData={agileFilesList[fileId]}
                                                        fileType={agileFilesList[fileId]?.fileType}
                                                        fileName={agileFilesList[fileId]?.fileName}
                                                        viewType={viewType}/>
                                                ) : (
                                                    <FileRow
                                                        key={index}
                                                        fileId={fileId}
                                                        fileData={agileFilesList[fileId]}
                                                        fileType={agileFilesList[fileId]?.fileType}
                                                        fileName={agileFilesList[fileId]?.fileName}/>
                                                )
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                open={snackBarOpen}
                autoHideDuration={3000}
                onClose={handleSnackBarClose}>
                <Alert
                    onClose={handleSnackBarClose}
                    severity={snackBarType}
                    variant='filled'
                    sx={{ width: '100%' }}>
                    {snackBarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}